/* rk-cart-merge.js (r55, 16 Oct 2026, Alexander: "Merge would be nicer"). The cart drawer and /cart print the lines that Shopify's buy-1-get-1 discounts
   split (same product and colour, full price + discounted) as ONE row (snippets/rk-cart-group.liquid). Such a row carries data-rk-lines="key=qty;key=qty"
   on its quantity input and remove control. This file turns the stepper, a typed quantity and remove into ONE /cart/update.js for those lines:
   more = added to the first line (Shopify re-splits it), fewer = taken from the last lines first, remove = every line to 0. Then the drawer / cart
   sections are re-rendered with window.RKCart (assets/bf26y-giftguard.js), which also re-adds a free gift if one is still earned.
   Rows of a single line are left to the theme. Rollback: remove the script tag in snippets/bf26z-sitewide.liquid. */
(function () {
  'use strict';
  if (window.__rkcm) return;
  window.__rkcm = 1;
  function lines(el) {
    return (el.getAttribute('data-rk-lines') || '').split(';').filter(Boolean).map(function (p) {
      var i = p.lastIndexOf('=');
      return { key: p.slice(0, i), q: parseInt(p.slice(i + 1), 10) || 0 };
    });
  }
  function total(ls) { return ls.reduce(function (a, l) { return a + l.q; }, 0); }
  function plan(ls, target) {
    var u = {}, have = total(ls), i, left, d;
    if (target > have) { u[ls[0].key] = ls[0].q + (target - have); return u; }
    left = have - target;
    for (i = ls.length - 1; i >= 0 && left > 0; i--) { d = Math.min(ls[i].q, left); u[ls[i].key] = ls[i].q - d; left -= d; }
    return u;
  }
  var busy = false;
  function overlay(row, on) {
    if (!row) return;
    row.querySelectorAll('.loading-overlay').forEach(function (o) { o.classList.toggle('hidden', !on); });
    row.classList.toggle('rk-cm-busy', !!on);
  }
  function apply(el, target) {
    var ls = lines(el);
    if (!ls.length || busy) return;
    target = Math.max(0, target | 0);
    if (target === total(ls)) return;
    busy = true;
    var row = el.closest('.cart-item'), C = window.RKCart, ids = C && C.sectionIds ? C.sectionIds() : [];
    overlay(row, true);
    var body = { updates: plan(ls, target) };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !(j && +j.status >= 400), j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.sections && C && C.render) C.render(res.j.sections);
        else if (C && C.sync) C.sync();
        if (!res.ok) {
          var err = row && row.querySelector('.cart-item__error-text');
          if (err && res.j && (res.j.description || res.j.message)) err.textContent = res.j.description || res.j.message;
        }
        try { document.dispatchEvent(new CustomEvent('rk:cart-merged', { detail: { ok: res.ok } })); } catch (e) {}
      }, function () { if (C && C.sync) C.sync(); })
      .then(function () { busy = false; overlay(row, false); });
  }
  /* capture phase: runs before the theme's own quantity-input / cart-remove-button listeners, which only know one line */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('quantity-input .quantity__button, quantity-input button[name="plus"], quantity-input button[name="minus"]');
    if (b) {
      var inp = b.closest('quantity-input').querySelector('input[data-rk-lines]');
      if (!inp) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var step = parseInt(inp.getAttribute('step'), 10) || 1, now = total(lines(inp));
      var target = b.getAttribute('name') === 'plus' ? now + step : now - step;
      inp.value = Math.max(0, target);
      apply(inp, target);
      return;
    }
    var rm = t.closest('cart-remove-button[data-rk-lines]');
    if (rm) { e.preventDefault(); e.stopImmediatePropagation(); apply(rm, 0); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-rk-lines]')) return;
    e.stopImmediatePropagation();
    apply(t, parseInt(t.value, 10) || 0);
  }, true);
  /* Phase 1 wash bag rewards (20 Oct 2026): the colour swatch row on each /cart line (sections/main-cart-items.liquid, [data-rk-line-sw]).
     A tap adds the new colour with the row's quantity and line properties, then sets the old line(s) to 0, in that order so the paid piece count never
     dips below a rung on the way (the free gifts stay put); then the cart sections are re-rendered with window.RKCart. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rk-line-sw] button[data-v]') : null;
    if (!b || b.disabled || b.getAttribute('aria-pressed') === 'true' || busy) return;
    e.preventDefault();
    var box = b.closest('[data-rk-line-sw]'), id = parseInt(b.getAttribute('data-v'), 10);
    if (!id) return;
    var ls = (box.getAttribute('data-lines') || '').split(';').filter(Boolean).map(function (p) { var i = p.lastIndexOf('='); return { key: p.slice(0, i), q: parseInt(p.slice(i + 1), 10) || 0 }; });
    var q = total(ls), props = {};
    try { props = JSON.parse(box.getAttribute('data-props') || '{}') || {}; } catch (x) {}
    if (Array.isArray(props) || typeof props !== 'object') props = {}; // Liquid prints a line without properties as []
    if (!q || !ls.length) return;
    busy = true;
    var row = box.closest('.cart-item'), C = window.RKCart, ids = C && C.sectionIds ? C.sectionIds() : [];
    overlay(row, true);
    box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var post = function (url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !(j && +j.status >= 400), j: j }; }); });
    };
    var upd = {}; ls.forEach(function (l) { upd[l.key] = 0; });
    post('/cart/add.js', { items: [{ id: id, quantity: q, properties: props }] })
      .then(function (res) {
        if (!res.ok) return res;
        var body = { updates: upd };
        if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
        return post('/cart/update.js', body);
      })
      .then(function (res) {
        if (res.ok && res.j && res.j.sections && C && C.render) C.render(res.j.sections);
        else if (C && C.sync) C.sync();
        if (!res.ok) {
          var err = row && row.querySelector('.cart-item__error-text');
          if (err && res.j && (res.j.description || res.j.message)) err.textContent = res.j.description || res.j.message;
        }
      }, function () { if (C && C.sync) C.sync(); })
      .then(function () { busy = false; overlay(row, false); });
  }, true);
  /* a typed quantity also fires input events the theme debounces into a change: keep those away from the theme too */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-rk-lines]')) e.stopImmediatePropagation();
  }, true);
})();
